<template>
  <div class="mobile-table">
    <ul class="stock-list" v-loading="tableLoading">
      <li class="list-item" v-for="(stock,key) in  tableData" :key="key">
        <div class="name">{{key+1}} - 产品系列：{{stock.series==""?'暂无':stock.series}}</div>
        <el-row :gutter="10">
          <el-col :xs="12" :sm="12"></el-col>
          <el-col :xs="12" :sm="12"><strong>简码: </strong>{{stock.simpleCode==""?'暂无':stock.simpleCode}}</el-col>
          <el-col :xs="12" :sm="12"><strong>规格：</strong>{{stock.specification==""?'暂无':stock.specification}}</el-col>
          <el-col :xs="12" :sm="12" v-if="checkPermission(['EMPLOYEE'])"><strong>留货量：</strong>{{stock.reserveQuantity==""?'暂无':stock.reserveQuantity}}</el-col>
          <el-col :xs="12" :sm="12"><strong>可销售量：</strong>{{stock.quantity==""?'暂无':stock.quantity}}</el-col>
          <el-col :xs="12" :sm="12" v-if="checkPermission(['EMPLOYEE'])"><strong>色号：</strong>{{stock.color==""?'暂无':stock.color}}</el-col>
          <el-col :xs="12" :sm="12" v-if="checkPermission(['EMPLOYEE'])"><strong>等级：</strong>{{stock.grade==""?'暂无':stock.grade}}</el-col>
          <el-col :xs="12" :sm="12" v-if="checkPermission(['EMPLOYEE'])"><strong>包装：</strong>{{stock.pack==""?'暂无':stock.pack}}</el-col>
          <el-col :xs="12" :sm="12" v-if="checkPermission(['EMPLOYEE'])"><strong>单位：</strong>{{stock.unit==""?'暂无':stock.unit}}</el-col>
          <el-col :xs="12" :sm="12"><strong>仓库地区：</strong>{{stock.warehouse==""?'暂无':stock.warehouse}}</el-col>
          <el-col :xs="12" :sm="12" v-if="checkPermission(['EMPLOYEE'])"><strong>备注：</strong>{{stock.remark==""?'暂无':stock.remark}}</el-col>
        </el-row>
      </li>
    </ul>
  </div>
</template>
<script>
import { checkAuth } from '@/mixins';
import { checkPermission } from "@/utils/auth";
export default {
  name:'mobiletable',
  mixins:[checkAuth],
  props:['tableData','tableLoading'],
  created(){
  },
  methods:{checkPermission}
}
</script>
<style lang="scss" scoped>
.mobile-table{
  width: 100%;
  overflow: hidden;
  .stock-list{
    list-style-type: none;
    margin: 0;
    padding: 0;
    .list-item{
      text-align: left;
      padding: 8px 0;
      font-size: 14px;
      line-height: 28px;
      border-bottom: 1px solid #cacaca;
      .name{
        font-weight: bold;
        font-size: 15px;
        margin-bottom: 8px;
      }
    }
  }
}
</style>
